import React, { useMemo } from "react";
import FormHeader from "../../components/FormHeader";
import BaseFormPage from "../../components/BaseFormPage";
import BaseInput from "../../components/BaseInput";
import RadioGenders from "../../components/RadioGenders";
import BaseButton from "../../components/BaseButton";
import TermsAndPrivacy from "./components/TermsAndPrivacy";
import useViewController from "./viewController";
import useController from "./controller";
import BaseError from "../../components/BaseError";
import BirthDayDatePicker from "./components/BirthDayDatePicker";
import { useTranslation } from "react-i18next";
import BaseTextButton from "../../components/BaseTextButton";
import NavigateToIfAuth from "../../hocs/NavigateToIfAuth";
import FirstTimeInGameModal from "../../modals/FirstTimeInGameModal";
import { useNavigate } from "react-router-dom";
import buildInviteLink from "../../utils/buildInviteLink";
import ROUTES from "../../utils/routes.js";
import "./style.scss";
import GenderNotification from "../../modals/GenderNotification";
import SupportButton from "../../components/SupportButton";

export default NavigateToIfAuth(function RegisterAfterDemoGamePage() {
  const {
    onCheckTerms,
    isTermsAccept,
    onCheckPrivacy,
    isPrivacyAccept,
    onSetNextStep,
    currentStep,
  } = useViewController();
  const {
    isRegisterFormValid,
    onSubmitForm,
    isRegistrationLoading,
    responseServerErr,
    registerFormData,
    onBirthdayHandle,
    onComparableTextHandle,
    getValidGenders,
    isBirthdayValid,
    isValidEmail,
    handleChange,
    isValidPassword,
    isConsistency,
    comparableText,
    link,
  } = useController(onSetNextStep);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const title = useMemo(() => {
    if (currentStep === 2) {
      return "register_page.register_title";
    } else if (currentStep === 3) {
      return "invitePair.title";
    } else {
      return "";
    }
  }, [currentStep]);
  return (
    <div className="register-page">
      <FirstTimeInGameModal />
      <BaseFormPage
        renderActionFormButton={() =>
          currentStep !== 3 ? (
            // 29.10: те же классы, что у кнопки «Вход» в шапках игры (NavigateToLoginBtn):
            // рамка иконки без заливки, на hover перекрашивается только стрелка
            <BaseTextButton
              to={ROUTES.LOGIN_PAGE}
              icon="login"
              className="base-login-nav"
              iconStyle="base-login-nav-ic"
            >
              {t("login_acc")}
            </BaseTextButton>
          ) : null
        }
        backTo={currentStep === 3 ? "" : ROUTES.LOGIN_PAGE}
      >
        <FormHeader
          title={title.length ? t(title) : ""}
          titleClass="payment-page__title"
          subtitle={currentStep === 3 ? t("invitePair.subtitle") : ""}
        />
        {currentStep === 1 && (
          <div className="register-page__desc">
            <div>{t("register_page.desc1")}</div>
            <BaseButton onClick={() => onSetNextStep()}>
              {t("continue")}
            </BaseButton>
          </div>
        )}
        {currentStep === 2 && (
          <form
            onSubmit={onSubmitForm}
            className="register-page__register-form"
            action=""
          >
            <BaseInput
              id="register-name"
              inputMode="text"
              onChange={handleChange}
              name="firstName"
              value={registerFormData.firstName}
              autocomplete="off"
              maxlength={20}
              type="text"
              label={t("name_label")}
            />
            <div className="register-page__person-info">
              <RadioGenders
                type="register"
                formData={registerFormData}
                gender={registerFormData.gender}
                onChange={handleChange}
                getValidGenders={getValidGenders}
              />
            </div>
            <BirthDayDatePicker
              isBirthdayValid={isBirthdayValid}
              birthDay={registerFormData.birthday}
              onBirthdayHandle={onBirthdayHandle}
            />
            <BaseInput
              name="email"
              inputMode="email"
              value={registerFormData.email}
              id="register-email"
              onChange={handleChange}
              type="email"
              label={t("email_label")}
              autocomplete="off"
              errorMessage={
                !isValidEmail ? t("register_page.email_validate") : ""
              }
            />
            <BaseInput
              id="register-pass"
              onChange={handleChange}
              value={registerFormData.password}
              name="password"
              type="password"
              label={t("password_label")}
              errorMessage={
                !isValidPassword ? t("register_page.validate_pass") : ""
              }
            />
            <BaseInput
              id="register-repeat-pass"
              onChange={onComparableTextHandle}
              name="repeat_pass"
              value={comparableText}
              type="password"
              label={t("repeat_password_label")}
              errorMessage={!isConsistency ? t("register_page.same_pass") : ""}
            />
            <BaseError errorMessage={responseServerErr} />
            <TermsAndPrivacy
              checkedTerms={isTermsAccept}
              onCheckTerms={onCheckTerms}
              checkedPrivacy={isPrivacyAccept}
              onCheckPrivacy={onCheckPrivacy}
            />
            <BaseButton
              type="submit"
              loading={isRegistrationLoading}
              disabled={
                !isTermsAccept || !isPrivacyAccept || !isRegisterFormValid()
              }
              className="register-page__next-register"
            >
              {t("send")}
            </BaseButton>
          </form>
        )}
        {currentStep === 3 && (
          <>
            <div className="invite-wrapper__copy">
              <BaseInput
                id={`input-clipboard-target-1`}
                className="invite__info__link__input"
                value={buildInviteLink(link)}
                type="copy"
                copyOnClick={() => {}}
              />
              <BaseButton
                className="invite-wrapper__button"
                onClick={() => navigate(ROUTES.IN_GAME_PAGE)}
              >
                {t("continue")}
              </BaseButton>
            </div>
          </>
        )}
        <div className="register-aftert-page-support-btn">
          <SupportButton />
        </div>
      </BaseFormPage>
    </div>
  );
}, ROUTES.PERSONAL_ACCOUNT_PAGE);
